export const ResendModalConstants = {
    SUCCESS_HEADING: 'Check your email',
    SUCCESS_MESSAGE: 'Your username and account information have been resent to the email you provided.',
    FAILURE_HEADING: 'Email unable to be sent',
    FAILURE_MESSAGE: 'We were unable to resend your username and account information at this time. Please try again.',
};
